/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React from 'react';
import ThemeLogo from '../themecolorplate/Global.scss';

const logo = ThemeLogo.ThemeLogo;
export const HeaderLogo = require(`../img/${logo}.svg`);
